import React, { useState, useEffect } from "react";
import "./index.scss";
import axiosInstance from "../../../../services/api/API";
import CustomTable from "../../../../customComponents/CustomTable";
import { useNavigate } from "react-router-dom";
import editIcon from "../../../../../Assets/icons/Un-Checkbox.svg";
import viewIcon from "../../../../../Assets/icons/eye 1.svg";
import redirection from "../../../../../Assets/icons/SalesRedirection.svg";
import searchIcon from "../../../../../Assets/icons/searchicon.svg";
import { IoMdClose } from "react-icons/io";
import download from "../../../../../Assets/icons/download.svg";
import DownloadSVG from "../../../../../Assets/icons/DownloadIconMIS.svg";
import moment from "moment";
import * as base64 from "base-64";
import ListLogisticsFilters from "../../../Logistics/LogisticsFilter";
import SearchInput from "../../../../customComponents/CustomSearch/SearchInput";
import Loader from "../../../../customComponents/CustomLoader";
import { FiDownload } from "react-icons/fi";

const JobCardList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [jobCardList, setJobCardList] = useState([]);
  const [filterList, setFilterList] = useState();
  const [totalRecords, setTotalRecored] = useState(0);
  const [filterFormData, setFilterFormData] = useState({});
  const [modelOptions, setModelOptions] = useState([]);

  const [validationErrors, setValidationErrors] = useState({});
  const [filters, setFilters] = useState({});
  const [totalJobRecord, setTotalJobRecord] = useState(null);
  const [dealerOption, setDealerOptions] = useState([]);

  // const [tableLoader,setTableLoader]=useState(false);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const userType = localStorage.getItem("UserType");
  const engineer_id = localStorage.getItem("engineer_id");
  localStorage.removeItem("JobCardComplainData");

  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    // Format to YYYY-MM-DD without timezone influence
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10);
  };

  useEffect(() => {
    fetchJobCardList();
  }, [filterList]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchJobCardList(newPage);
  };
  const DownLoadPdf = (row) => {
    var text = row?.job_card_id;
    var encoded = base64.encode(text);
    const pdfURL = `${process.env.REACT_APP_API_BASE_URL}jobcardpdfreport/jobCardInvoiceDownload/${encoded}`;
    window.open(pdfURL, "_blank", "noopener,noreferrer");
  };

  const redirectionFunc = (row) => {
    console.log(row, "RowJobCardList");
    navigate("/manage-sales/productlist/generate-order", {
      state: { jobCardDataDetails: JSON.parse(JSON.stringify(row)) },
    });
  };

  useEffect(() => {
    fetchJobCardList();
  }, []);

  // useEffect(() => {
  //   console.log(filterFormData, "filteredFormData")
  // })

  const fetchJobCardList = async (page = 0, pageSize = 10) => {
    const allfilteredData = filters;
    const payload = {
      // business_partner_id: 1,
      orderBy: "job_card_id desc",
      page,
      pageSize,
      // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
      status: allfilteredData?.status,
      // toDate: allfilteredData?.toDate ? allfilteredData?.toDate : "",
      fromDate: formatDate(allfilteredData?.fromDate),
      toDate: formatDate(allfilteredData?.toDate),
      service_type: allfilteredData?.service_type
        ? allfilteredData?.service_type
        : null,
      // searchText: searchTerm,
      searchText: searchTerm?.trim() ? searchTerm.trim() : null,
      dealer_id: allfilteredData?.dealerId ? allfilteredData?.dealerId : null,
      model_id: allfilteredData?.model_id ? allfilteredData?.model_id : null,
      engineerId: engineer_id || null,
    };
    console.log(allfilteredData, "filtered Datas in payload");
    try {
      // setTableLoader(true)
      setLoading(true);
      const response = await axiosInstance.post("/jobcard/list", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      // setTableLoader(false)
      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
        // status: item?.status === 0 ? "Pending" : "Done",
        engineer_name: item.engineer_name || "--",
        rejactRemark: item.rejactRemark || "--",
        // job_card_no: onClickNavigetion(item),
        created_at: item?.created_at || "--",

        isApproved: item?.isApproved == 0 ? "Inactive" : "Active",
      }));
      if (response?.status == 200) {
        setJobCardList(formattedData);
        setTotalRecored(response?.data?.data?.total);
        setTotalPages(Math.ceil(response?.data?.data?.total / pageSize));
        setTotalJobRecord(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching business partners:", error);
    } finally {
      setLoading(false);
    }
  };

  const onClickNavigetion = (item) => {
    return (
      <div onClick={() => handleEdit(item)}>
        <span style={{ color: "green" }}> {item?.job_card_no}</span>
      </div>
    );
  };

  const Status = (item) => {
    return (
      <div
        style={{
          display: "flex",
          backgroundColor: item?.solved == 0 ? "#FEEBEB" : "#E4F7E3",
          width: 90,
          justifyContent: "center",
          paddingTop: 4,
          paddingBottom: 4,
          borderRadius: 10,
        }}
      >
        <span style={{ fontSize: 18 }}>
          {item?.solved == 0 ? "Pending" : "Done"}
        </span>
      </div>
    );
  };

  const handleEdit = (rowData) => {
    navigate("/manage-services/check-warranty/edit-job-card", {
      state: { jobCardDataDetails: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  const handleViewButton = (rowData) => {
    navigate("job-card-details", {
      state: { data: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  // const filteredBusinessPartners = businessPartners.filter((item) =>
  //   item.bp_name.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  // Table headers
  const Job_Card_TABLE_HEADERS = [
    "Job Card No.",
    "Dealer Name",
    // "Business Partner ID",
    "Job Card Created Date",
    // "Job Card Done Date",
    // "Registration No.",
    // "Dealer Trade Date",
    "Vin No.",
    // "Inspect By",
    // "Pin Code",
    // "Job Type",
    // "Service Type",
    // "Remark",
    // "Engineer Name",
    // "Service Charges",
    // "Engineer Paid Amount",
    "Job Status",
    "Action",
  ];
  // paid_amount
  // Key mapping for CustomTable component
  const BUSINESS_PARTNER_KEY_MAPPING = {
    "Job Card No.": "job_card_no",
    "Engineer Name": "engineer_name",
    "Service Charges": "paid_amount",
    "Dealer Name": "dealer_name",
    // "Business Partner ID": "onboard_id",
    "Dealer Trade Date": "dealer_warrnty_date",
    "Job Card Created Date": "created_at",
    "Job Card Done Date": "jobcard_done_date",
    "Customer Name": "customer_name",
    "Registration No.": "registration_no",
    "Vin No.": "vin_no",
    "Service Type": "service_type",
    // "Inspect By":"inspection_by",
    "Vehicle Type": "product_name",
    "Pin Code": "pincode",
    "Admin Amount": "adminAmt",
    "Engineer Paid Amount": "eng_paid_amount",
    Remark: "rejactRemark",
    "Job Type": "jobTypeName",

    "Job Status": "status",
    Action: [
      {
        type: "edit",
        icon: editIcon,
        label: "Edit",
      },

      {
        type: "view",
        icon: viewIcon,
        label: "View",
      },
      // {
      //   type: "print",
      //   icon: download,
      //   label: "Print",
      // },
      {
        type: "redirection",
        icon: redirection,
        label: "Redirection",
      },
    ],
  };

  // const handleClicableRow = (row) => {
  //   alert("hello")
  //   setFilterList(row);
  // };

  const onclickFilter = (row) => {
    setFilterList(row);
  };

  useEffect(() => {
    fetchJobCardList();
  }, [filters]);

  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    setSearchTerm("");
    fetchJobCardList(0, 10);
  };

  useEffect(() => {
    if (searchTerm === "") {
      fetchJobCardList();
    }
  }, [searchTerm]);

  const handleSearch = () => {
    console.log(filterFormData, "filteredFormData");
    setFilters({
      fromDate: filterFormData.startDate || null,
      toDate: filterFormData.endDate || null,
      service_type: filterFormData.service_type || null,
      dealerId: filterFormData.dealerId || null,
      model_id: filterFormData.model_id || null,
      status:
        filterFormData.status !== undefined && filterFormData.status !== ""
          ? filterFormData.status
          : null,
    });
  };
  const clearSearchAndFetch = () => {
    setSearchTerm("");
  };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const handelkeyDown = (event) => {
    if (event.key === "Enter") {
      fetchJobCardList({ searchText: searchTerm });
    }
  };

  useEffect(() => {
    fetchDealers();
  }, []);

  const fetchDealers = async () => {
    try {
      const response = await axiosInstance.post("/dealer/ddldealer", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response?.data?.data?.data;

      const dealerOptions = data.map((dealer) => ({
        value: dealer.dealer_id,
        label: dealer.dealer_name,
      }));

      setDealerOptions(dealerOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchModelOptions();
  }, []);

  const fetchModelOptions = async () => {
    try {
      const payload = {
        orderBy: "model_id desc",
        page: 0,
        pageSize: 100,
      };

      const response = await axiosInstance.post("/model/ddlmodel", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));
      console.log(options, "responseVal");

      setModelOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  const PhysicalStockTakingInputs = [
    {
      name: "startDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-12 col-lg-3",
    },
    {
      name: "endDate",
      label: "To Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-12 col-lg-3",
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      placeholder: "Select Complaint",
      options: [
        { label: "Pending", value: 0 },
        { label: "Completed", value: 1 },
      ],
      gridClass: "col-lg-3",
    },
  ];

  if (userType === "businesspartner") {
    // PhysicalStockTakingInputs.push({
    //   name: "service_type",
    //   label: "Service Type",
    //   placeholder: "Select Service Type",
    //   type: "dropdown",
    //   options: [
    //     { label: "Free Service", value: 0 },
    //     { label: "Paid Service", value: 1 },
    //     { label: "Within Warranty", value: 2 },
    //   ],
    //   required: true,
    //   gridClass: "col-12 col-lg-3",
    // });
  }

  if (userType === "businesspartner") {
    // PhysicalStockTakingInputs.push({
    //   name: "model_id",
    //   label: "Model",
    //   placeholder: "Select Model",
    //   type: "dropdown",
    //   options: modelOptions,
    //   required: true,
    //   gridClass: "col-12 col-lg-3",
    // });
  }

  if (userType === "businesspartner") {
    PhysicalStockTakingInputs.push({
      name: "dealerId",
      label: "Dealer ",
      placeholder: "Select Dealer",
      type: "dropdown",
      options: dealerOption,
      // required: true,
      gridClass: "col-lg-3",
    });
  }

  const downloadExcel = async () => {
    const allfilteredData = filters;
    const payload = {
      // dealerId: dealerId,
      // state_id: "",
      // services_by: "",
      // servicesValue_Id: "",
      // orderBy: "po_id desc",
      // page: 0,
      // pageSize: 10,
      // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : null,
      // toDate: allfilteredData?.toDate ? allfilteredData?.toDate : null,
      orderBy: "job_card_id desc",
      page: 0,
      pageSize: 10,
      dealer_id: allfilteredData?.dealerId ? allfilteredData?.dealerId : null,
      model_id: allfilteredData?.model_id ? allfilteredData?.model_id : null,
      // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
      // toDate: allfilteredData?.toDate ? allfilteredData?.toDate : "",
      fromDate: formatDate(allfilteredData?.fromDate),
      toDate: formatDate(allfilteredData?.toDate),
      status: allfilteredData?.status ? allfilteredData?.status : "",
      service_type: allfilteredData?.service_type
        ? allfilteredData?.service_type
        : null,
    };

    try {
      const response = await axiosInstance.post(
        "/jobcard/jobCardExportExcel",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob", // Important: Ensures the response is treated as a file
        }
      );

      // Create a Blob from the response
      const blob = new Blob([response.data], { type: "text/csv" });

      // Create a download link
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "JobCard_report.csv"; // Set the file name
      link.style.display = "none";

      // Append the link to the body and trigger the download
      document.body.appendChild(link);
      link.click();

      // Clean up the link element
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  };

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="OnboardManagamentContainer ">
            <div className="OnboardManagamentbuttonContainer  col-md-3 mt-2 mb-2">
              <div
                style={{
                  lineHeight: "1px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div>
                  <p className="ServiceBreadcrumbs">
                    Services / Check Warranty
                  </p>
                </div>
                <div>
                  <h5 style={{ fontWeight: "600" }}>Service Job Card</h5>
                </div>
              </div>
            </div>
            <div className=" col-md-8 mt-2 mb-2 gap-2 totalvaluescontainer">
              {/* <div className="topleftdataContainer">
              <div className="listTopDataValueText">
                {totalJobRecord?.total || 0}{" "}
              </div>
              <div>Total Job</div>
            </div> */}
              {/* <div className="topleftdataContainer">
              <div className="listTopDataValueText">
                {totalJobRecord?.total_pending || 0}{" "}
              </div>
              <div>Pending Job</div>
            </div> */}
              {/* <div
              // key={}
              className="topleftdataContainer"
            >
              <div className="listTopDataValueText">
                {totalJobRecord?.total_completed || 0}{" "}
              </div>
              <div>Completed Job</div>
            </div> */}
              {/* <div
              // key={}
              className="topleftdataContainer"
              style={{ paddingRight: "10px" }}
            >
              <div className="listTopDataValueText">
                &#8377;{totalJobRecord?.total_revenue || 0}
              </div>
              <div>Revenue</div>
            </div> */}
              <div className="listSideBorder" />

              <button
                className="addcustomerbutton"
                onClick={() => navigate("add-Job-Card")}
              >
                Add Job Card
              </button>
            </div>
          </div>
          <div className="tableWrapper">
            <div className="filterView">
              <div className="filterLeftView col-md-4 pt-4 gap-2">
                <h5 className="all-jobcard-list">All Job Card List</h5>
                <div>
                  <SearchInput
                    placeholder="Search..."
                    onSearch={fetchJobCardList}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    showSearchButton={false}
                  />
                </div>
              </div>
              <div className="filterRightView col-md-8 gap-2">
                {/* <div className="mt-3">
                  <h5
                    className="job-card-filter-by"
                    style={{ paddingTop: "20px", width: "6rem" }}
                  >
                    Filter By
                  </h5>
                </div> */}

                <ListLogisticsFilters
                  formConfig={PhysicalStockTakingInputs}
                  formData={filterFormData}
                  setFormData={setFilterFormData}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors}
                  handleSearch={handleSearch}
                  handleClear={clearFilter}
                  // onSubmit={handleFormSubmit}
                />

                <div
                  onClick={downloadExcel}
                  className="flte-btnnn"
                  style={{ borderRadius: "38px", cursor: "pointer" }}
                >
                  Export
                  <span>
                    <FiDownload
                      className="downloadexcel-misreportsales"
                      style={{ cursor: "pointer" }}
                      size={22}
                    />
                  </span>
                </div>
              </div>
            </div>

            <CustomTable
              data={jobCardList}
              headers={Job_Card_TABLE_HEADERS}
              keyMapping={BUSINESS_PARTNER_KEY_MAPPING}
              onEdit={handleEdit}
              handleViewButton={handleViewButton} // Pass the handleEdit function
              itemsPerPage={10}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              //  handleClicableRow={handleClicableRow}
              pdfDownLoad={DownLoadPdf}
              redirectionFunc={redirectionFunc}
              totalRecords={totalRecords}
              // tableLoaderShow={tableLoader}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default JobCardList;
